@if (!!accounts) {
  <arpio-center-panel>
    @if (accounts.length > 1) {
      <div>
        <arpio-accounts-list [accounts]="accounts"></arpio-accounts-list>
        <div class="logout-container margin-top margin-left">
          <a id="accounts-logout-link" routerLink="" (click)="logoutClick()">Sign out &nbsp;<svg lucideLogOut></svg></a>
        </div>
      </div>
    } @else {
      <h3 class="panel-title">
        Hmm... it looks like you don't have access to any {{ uiService.productName }} accounts.
      </h3>
      <p>
        You may simply be missing the proper permissions.<br />Please contact your account administrator, or
        <a id="no-accounts-logout-link" routerLink="" (click)="logoutClick()">login as another user</a>
      </p>
    }
  </arpio-center-panel>
}
